import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { dotPop } from '../Utils';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';
import FontKeys from '../FontKeys';

export default class CarveHUD extends Phaser.GameObjects.Container {

  static get UNDO() {return 'UNDO';}

  static get RESET() {return 'RESET';}

  static get LIGHT() {return 'LIGHT';}

  static get TOGGLE_TIME() {return 'TOGGLE_TIME';}

  constructor (scene) {
    super(scene);

    this.btnContainer = null;

    this.undoEvent = CarveHUD.UNDO;
    this.resetEvent = CarveHUD.RESET;
    this.lightEvent = CarveHUD.LIGHT;
    this.toggleEvent = CarveHUD.TOGGLE_TIME;

    this.btnContainer = this.scene.add.container();

    this.btnUndoContainer = this.scene.add.container(0, 0).setScale(0);
    this.btnContainer.add(this.btnUndoContainer);

    // btn undo bg
    this.btnUndo = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._BtnUndo, this.btnUndoContainer).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickUndo, this);

    // btn undo txt
    if (ABCyaLib.Environment.instance.gameConfig.useCurvedTextOnButtons) {
      const curvedText = ABCyaPhaser.Text.addCurvedText(-2,-1,14, 0xffffff, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString('undo_button'), this.btnUndo.width / 2 - 20, this.btnUndoContainer, -90 * Phaser.Math.DEG_TO_RAD, 1.5, true, true);
    }
    else {
      this.btnUndoContainer.add(this.scene.add.bitmapText(0,-26,'bpreplay-bold', ABCyaPhaser.Localization.instance.getLocalizedString('undo_button'), 18, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5));
      ABCyaPhaser.Text.resizeFontToFitWidth(this.btnUndoContainer.getAt(1), 52, 20);
    }

    this.btnResetContainer = this.scene.add.container(this.btnUndo.width + 5, 0).setScale(0);
    this.btnContainer.add(this.btnResetContainer);

    // btn reset bg
    this.btnReset = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._BtnReset, this.btnResetContainer).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickReset, this);

    // btn reset txt
    if (ABCyaLib.Environment.instance.gameConfig.useCurvedTextOnButtons) {
      const curvedText = ABCyaPhaser.Text.addCurvedText(-1,-1,14, 0xffffff, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString('reset_button'), this.btnReset.width / 2 - 20, this.btnResetContainer, -90 * Phaser.Math.DEG_TO_RAD, 1.5, true, true);
    }
    else {
      this.btnResetContainer.add(this.scene.add.bitmapText(0,-26,'bpreplay-bold', ABCyaPhaser.Localization.instance.getLocalizedString('reset_button'), 18, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5));
      ABCyaPhaser.Text.resizeFontToFitWidth(this.btnResetContainer.getAt(1), 52, 20);
    }

    this.btnToggleTime = ABCyaPhaser.Images.addImage(this.scene.scale.width - 120, 0, UIAssetKeys._BtnNighttime, this.btnContainer).setScale(0);
    this.btnToggleTime.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickToggleTime, this);

    this.btnLight = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._BtnLight, this.btnContainer).setScale(0);
    this.btnLight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickLight, this);

    this.btnContainer.x = Math.floor(this.btnUndo.width / 2);
    this.btnContainer.y = Math.floor(this.btnUndo.height / 2) - 40;

    this.add(this.btnContainer);

    dotPop(this.btnUndoContainer).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnUndo.setInteractive());
    dotPop(this.btnResetContainer).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnReset.setInteractive());
    dotPop(this.btnToggleTime).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnToggleTime.setInteractive());
  };

  clickUndo() {
    this.emit(this.undoEvent);
  };

  clickReset() {
    this.emit(this.resetEvent);
    this.btnUndo.disableInteractive();
    this.btnReset.disableInteractive();
    this.btnToggleTime.disableInteractive();
    this.btnLight.disableInteractive();
    ABCyaPhaser.Tweens.addTween([this.btnUndoContainer, this.btnResetContainer, this.btnToggleTime], 140, { scale: 0 }, Phaser.Math.Easing.Linear);
  };

  clickToggleTime() {
    this.btnLight.disableInteractive();
    this.btnUndo.disableInteractive();
    this.btnReset.disableInteractive();
    this.btnToggleTime.disableInteractive();
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
    this.emit(this.toggleEvent);
  };

  clickLight() {
    this.emit(this.lightEvent);
  };

  updateLightButton(islit) {
    if (islit) {
      this.btnLight.setFrame(UIAssetKeys._BtnLightOff);
    }
    else {
      this.btnLight.setFrame(UIAssetKeys._BtnLight);
    }
  };

  hideHud(isNighttime) {
    this.btnLight.disableInteractive();
    this.btnUndo.disableInteractive();
    this.btnReset.disableInteractive();
    this.btnToggleTime.disableInteractive();
    if (isNighttime) {
      this.switchToNightHud();
    }
    else {
      this.switchToDayHud();
    }
  };

  switchToNightHud() {
    this.updateLightButton(false);
    ABCyaPhaser.Tweens.addTween([this.btnUndoContainer, this.btnResetContainer, this.btnToggleTime], 140, { scale: 0 }, Phaser.Math.Easing.Linear);
  };

  switchToDayHud() {
    ABCyaPhaser.Tweens.addTween([this.btnToggleTime, this.btnLight], 140, { scale: 0 }, Phaser.Math.Easing.Linear);
  };

  activate(isNighttime) {
    if (isNighttime) {
      this.btnToggleTime.setFrame(UIAssetKeys._BtnDaytime);
      dotPop(this.btnToggleTime).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnToggleTime.setInteractive());
      dotPop(this.btnLight).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnLight.setInteractive());
    }
    else {
      this.btnToggleTime.setFrame(UIAssetKeys._BtnNighttime);
      dotPop(this.btnToggleTime).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnToggleTime.setInteractive());
      dotPop(this.btnUndoContainer).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnUndo.setInteractive());
      dotPop(this.btnResetContainer).once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.btnReset.setInteractive());
    }
  };
}